import { useState } from "react";
import { Leaf } from "lucide-react";
import { useProducts } from "@/hooks/useCatalogue";
import PageIntro from "@/components/PageIntro";

export default function ThreeWaySystem() {
  const { data: products = [] } = useProducts();
  const [active, setActive] = useState(0);
  const current = products[active];

  return (
    <div>
      <PageIntro
        eyebrow="Formulation with Intention"
        title="The 3-Way System"
        description="Our formulation architecture organises each product around three considered pathways. This is the architecture name—not a usage instruction. All pathway details are being finalised."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="flex flex-wrap gap-2 mb-8">
          {products.map((p, i) => (
            <button
              key={p.id}
              onClick={() => setActive(i)}
              className={`rounded-full px-6 py-3 text-sm font-medium transition-colors ${
                active === i ? "bg-forest text-ivory" : "border border-forest/25 text-forest hover:bg-forest/5"
              }`}
            >
              {p.name}
            </button>
          ))}
        </div>
        {current && (
          <div className="grid md:grid-cols-3 gap-4">
            {(current.pathways || [1, 2, 3]).map((pw, i) => (
              <div key={i} className="border border-forest/15 bg-cream p-8">
                <div className="flex items-center gap-2 text-champagne">
                  <Leaf size={16} />
                  <span className="text-[10px] uppercase tracking-[0.24em] text-moss">
                    Pathway {i + 1}
                  </span>
                </div>
                <p className="mt-4 font-serif text-2xl text-forest">To be confirmed</p>
                <p className="mt-2 text-sm text-charcoal/60">
                  Formulation details will be shared soon.
                </p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
